import classnames from 'classnames';

import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { TooltipText, TooltipTextProps } from './TooltipText';

const useStyles = createUseStyles((theme: Theme) => ({
  questionIcon: {
    fontSize: theme.iconSize.regular,
    fontWeight: 400,
  },
  container: {
    ...theme.fonts.caption,
    color: theme.colors.blue,
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.marginBase / 2}px`,
  },
  text: {},
  gray: {
    color: theme.colors.inkTertiary,
  },
}));

interface Props extends Partial<TooltipTextProps> {
  className?: string;
  variant?: 'blue' | 'gray';
}

export const QuestionTooltip = ({ className, children, ...props }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  if (!props.title) {
    return null;
  }

  return (
    <TooltipText {...props}>
      <div
        className={classnames(
          classes.container,
          {
            [classes.gray]: props.variant === 'gray',
          },
          className,
        )}
      >
        {!!children && <div>{children}</div>}
        <i className={classnames('ri-question-line', classes.questionIcon)} />
      </div>
    </TooltipText>
  );
};
